import { InternalConnection } from "@shared/constants";
import { TenantConnectionConfig } from "@shared/utils";

export const config: TenantConnectionConfig<InternalConnection | undefined> = {
  ig: {
    prod: "ig-ad",
    qa: "ig-ad-qa",
    staging: undefined, // keep undefined for local dev and staging we dont need to defined an SSO
    demo: "ig-ad-qa",
  },
  "ig-dev": {
    qa: "ig-ad-dev",
    staging: "ig-ad-dev",
    demo: "ig-ad-dev",
  },
};
